import React, { useLayoutEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Home, ProjectDetails } from './Pages'
import { themeCheck } from './utils/functions'
const App = () => {
  useLayoutEffect(() => {
    themeCheck()
  }, [])
  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/project-id/id' element={<ProjectDetails />} />
      </Routes>
    </>
  )
}

export default App
